// extracted by mini-css-extract-plugin
module.exports = {"userButton":"UserIcon_userButton__2f0WO","dropDown":"UserIcon_dropDown__2Tn6u"};